import React from "react";
import { Input } from "@/components/ui/input";
import { Section, Field, SelectField } from "@/components/assessment/FormPrimitives";
import {
  PLATFORMS, LEAD_TIMES, PURPOSES, YES_NO,
} from "@/lib/risk";

export const BookingSection = ({ form, set, setNum }) => (
  <Section title="Booking & platform">
    <Field label="Guest initials" hint="Initials only — never enter a full guest name.">
      <Input value={form.guest_initials} onChange={(e) => set("guest_initials")(e.target.value)} placeholder="e.g. J.D." maxLength={6} data-testid="field-guest-initials" />
    </Field>
    <Field label="Booking platform">
      <SelectField value={form.platform} onChange={set("platform")} options={PLATFORMS} testid="field-platform" />
    </Field>
    <Field label="Booking lead time">
      <SelectField value={form.lead_time} onChange={set("lead_time")} options={LEAD_TIMES} testid="field-lead-time" />
    </Field>
    <Field label="Purpose of stay">
      <SelectField value={form.purpose} onChange={set("purpose")} options={PURPOSES} testid="field-purpose" />
    </Field>
    <Field label="Length of stay (nights)">
      <Input type="number" min={1} value={form.length_of_stay} onChange={setNum("length_of_stay")} data-testid="field-length-of-stay" />
    </Field>
    <Field label="Number of guests">
      <Input type="number" min={1} value={form.num_guests} onChange={setNum("num_guests")} data-testid="field-num-guests" />
    </Field>
    <Field label="Weekend stay">
      <SelectField value={form.weekend_stay} onChange={set("weekend_stay")} options={YES_NO} testid="field-weekend" />
    </Field>
    <Field label="Public holiday / event period">
      <SelectField value={form.public_holiday} onChange={set("public_holiday")} options={YES_NO} testid="field-public-holiday" />
    </Field>
  </Section>
);
